import React from 'react';
import moment from 'moment'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import {
  Col, Card, CardImg, CardText, CardBody
} from 'reactstrap'

const Content = ({
  _id,
  Contents,
  CreateOn,
  Image,
  Author,
  styleCol
}) => {
  return (
    <Col md={styleCol}>
      <Card>
        <CardImg top width="100%" src={Image} />
        <CardBody>
          <div class="d-flex align-items-center m-t-5">
            <div class="avatar avatar-image avatar-sm">
              <img src={Author.HinhDaiDien} alt="" />
            </div>
            <div class="m-l-10">
              <span class="font-weight-semibold">{Author.HoTen}</span>
            </div>
          </div>
          <CardText className="text2line">
            {Contents}
          </CardText>
          <div className="d-flex align-items-center justify-content-between">
            <CardText >
              {moment(CreateOn).fromNow()}
            </CardText>
            <Link to={"/admin/contents/id/" + _id}>
              Xem thêm
            </Link>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

Content.propTypes = {
  _id: PropTypes.string,
  Contents: PropTypes.string,
  CreateOn: PropTypes.string,
  Image: PropTypes.string,
  Author: PropTypes.object,
  styleCol: PropTypes.number
};

Content.defaultProps = {
  type: 'text'
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/common/Content.js